var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJahez(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 370.5 205.2",
    style: {
      enableBackground: "new 0 0 370.5 205.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5A800;}\n\t.st1{fill:#E21A2D;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.5,113.6c-6.9,0-13.1-6.2-13.1-13.1s6.2-13.1,13.1-13.1c6.9,0,13.1,6.2,13.1,13.1 C125.7,107.4,120.3,113.6,112.5,113.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.6,131.3v-88h14.7v33.2c3.9-5.4,10.8-10,20.1-10c6.9,0,12.3,2.3,17,6.9c4.6,4.6,6.9,10.8,6.9,19.3v38.6 h-15.4V96.6c0-10.8-5.4-16.2-13.9-16.2c-9.3,0-15.4,6.9-15.4,17v34C173.5,131.3,159.6,131.3,159.6,131.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243,94.3h34c-1.5-8.5-7.7-14.7-16.2-14.7C251.5,79.6,245.3,85,243,94.3 M291.6,105.1h-47.9 c2.3,8.5,8.5,14.7,19.3,14.7c7.7,0,14.7-2.3,20.8-6.2l6.2,10.8c-7.7,6.2-17,8.5-27.8,8.5c-23.9,0-34-16.2-34-33.2 c0-9.3,3.1-17.8,9.3-23.9c6.2-6.2,13.9-9.3,23.9-9.3c9.3,0,17,3.1,22.4,8.5c6.2,5.4,8.5,13.1,8.5,23.2 C291.6,100.5,291.6,102.8,291.6,105.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "321.7,119 354.9,119 354.9,131.3 300.9,131.3 300.9,121.3 333.3,81.2 302.4,81.2 302.4,68.8  354.1,68.8 354.1,78.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.3,68.8H38.4v15.4h16.2v35.5c0,10.8-6.2,17.8-16.2,17.8c-6.2,0-11.6-2.3-16.2-7.7l-7.7,11.6 c6.9,6.9,15.4,10,25.5,10c9.3,0,16.2-2.3,21.6-7.7c5.4-5.4,8.5-13.1,8.5-23.2v-37l0,0V68.8H69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.4,68.8v5.4c-5.4-4.6-12.3-6.9-20.1-6.9c-18.5,0-33.2,14.7-33.2,33.2s14.7,33.2,33.2,33.2 c7.7,0,14.7-2.3,20.1-6.9v5.4h13.9V68.8H133.4z M112.5,120.5c-11.6,0-20.1-9.3-20.1-20.1c0-11.6,9.3-20.1,20.1-20.1 c11.6,0,20.1,9.3,20.1,20.1S124.1,120.5,112.5,120.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJahez);
export default __webpack_public_path__ + "static/media/jahez.0a4e70cb16dc09e3c8b1ce7aa03d38ff.svg";
export { ForwardRef as ReactComponent };